import { IEventSchema } from '@faire/web-api--source/indigofair/data/IEventSchema';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web/common/pete/TraceEventTracker';

export const eventKey =
  'brand_tile-market_list_brand_tile_add-action_category_click';

/**
 * This event tracks when the user clicks a button to add to or remove a brand from their market list. 

Action: "DELETE" | "ADD"
Page: "UNSPECIFIED" | "MARKET_LIST" | "MARKET_HUB" | "NOW_ON_FAIRE"
 */
export function trackBrandTileMarketListBrandTileAddActionCategoryClick(
  brandToken: string,
  Action: string,
  Page2: string = 'UNSPECIFIED'
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    priority: IEventSchema.Priority.EXTRA_LOW,
    parameters: { brandToken, Action, Page2 },
  });
}
